import { render, staticRenderFns } from "./Conduct.vue?vue&type=template&id=13bb9889&scoped=true"
var script = {}
import style0 from "./Conduct.vue?vue&type=style&index=0&id=13bb9889&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bb9889",
  null
  
)

export default component.exports